import {
  ShigoDeploymentTarget,
  ShigoNetwork,
  isShigoDeploymentTarget,
  isShigoNetwork,
  resolveShigoDeploymentProfile,
} from './deployment';

type ShigoAppConfig = ReturnType<typeof resolveShigoDeploymentProfile>;

type ShigoEnvironment = {
  DEV?: boolean;
  VITE_SHIGO_API_BASE_URL?: string;
  VITE_SHIGO_REPORTING_SERVICE_URL?: string;
  VITE_SHIGO_MADBUY_SERVICE_URL?: string;
  VITE_SHIGO_MADSENSE_SERVICE_URL?: string;
  VITE_SHIGO_NETWORK_ID?: string;
  VITE_SHIGO_NETWORK?: string;
  VITE_SHIGO_DEPLOYMENT_TARGET?: string;
};

export function readShigoAppConfig(
  environment: ShigoEnvironment = import.meta.env,
): ShigoAppConfig {
  const target = readDeploymentTarget(environment.VITE_SHIGO_DEPLOYMENT_TARGET);
  const network = readNetwork(environment.VITE_SHIGO_NETWORK);
  const profile = resolveShigoDeploymentProfile(target, network);
  const configuredApiBaseUrl = environmentString(environment, 'VITE_SHIGO_API_BASE_URL');
  const configuredNetworkId = environmentString(environment, 'VITE_SHIGO_NETWORK_ID');

  return {
    ...profile,
    apiBaseUrl: configuredApiBaseUrl || profile.apiBaseUrl,
    reportingServiceUrl:
      environmentString(environment, 'VITE_SHIGO_REPORTING_SERVICE_URL') ||
      profile.reportingServiceUrl,
    madBuyServiceUrl:
      environmentString(environment, 'VITE_SHIGO_MADBUY_SERVICE_URL') || profile.madBuyServiceUrl,
    madSenseServiceUrl:
      environmentString(environment, 'VITE_SHIGO_MADSENSE_SERVICE_URL') ||
      profile.madSenseServiceUrl,
    networkId: configuredNetworkId || profile.networkId,
  };
}

function environmentString(
  environment: ShigoEnvironment,
  key: keyof Pick<
    ShigoEnvironment,
    | 'VITE_SHIGO_API_BASE_URL'
    | 'VITE_SHIGO_NETWORK_ID'
    | 'VITE_SHIGO_REPORTING_SERVICE_URL'
    | 'VITE_SHIGO_MADBUY_SERVICE_URL'
    | 'VITE_SHIGO_MADSENSE_SERVICE_URL'
  >,
) {
  const value: unknown = environment[key];
  return typeof value === 'string' ? value.trim() : '';
}

function readDeploymentTarget(value: string | undefined) {
  if (!value) {
    return ShigoDeploymentTarget.Development;
  }
  if (isShigoDeploymentTarget(value)) {
    return value;
  }
  throw new Error(`Unsupported Shigo deployment target '${value}'.`);
}

function readNetwork(value: string | undefined) {
  if (!value) {
    return ShigoNetwork.Shigo;
  }
  if (isShigoNetwork(value)) {
    return value;
  }
  throw new Error(`Unsupported Shigo network '${value}'.`);
}
